import { createFileRoute } from "@tanstack/react-router";
import { ClientsTable } from "@/components/admin/ClientsTable/ClientsTable";
import { checkSuperUserPermission } from "@/lib/utils";

export const Route = createFileRoute("/_superuser/admin/clients")({
  component: ClientsPage,
  beforeLoad: () => {
    checkSuperUserPermission("user-management");
  },
});

function ClientsPage() {
  return <ClientsTable />;
}
